<script setup lang="ts">
import type { Schemas } from '#shopware'

defineProps<{
    popups: Schemas['Popup'][]
    currentPageType: string | undefined
}>()

const { hasConsent, initConsentTracking } = usePopupConsent()

onMounted(() => {
    initConsentTracking()
})
</script>

<template>
    <client-only>
        <template v-if="popups.length > 0 && hasConsent">
            <LazyPopupItem
                v-for="popup in popups"
                :key="popup.id"
                :data="popup"
                :current-page-type="currentPageType"
            />
        </template>
    </client-only>
</template>
